import type { $Fetch, FetchError, FetchOptions, MappedResponseType, ResponseType } from 'ofetch';
import type { Logger } from '@shared/types/types.ts';

/**
 *
 */
export abstract class BaseClient {
    protected constructor(
        private baseURL: string | undefined,
        private fetchClient: $Fetch,
        protected logger: Logger,
        protected timeout: number,
    ) {}

    async fetch<T, R extends ResponseType = 'json'>(
        request: RequestInfo,
        options?: FetchOptions<R>,
    ): Promise<MappedResponseType<R, T>> {
        return await this.fetchClient<T, R>(request, {
            baseURL: this.baseURL,
            timeout: this.timeout,
            ...(options || {}),
        }).catch((err: FetchError) => {
            if (!err?.statusCode || err.statusCode >= 500) {
                /*                                             */
                this.logger.info(err);
            }
            throw err;
        });
    }
}
